import { createFileRoute, Outlet } from "@tanstack/react-router";
// import { Card, CardHeader, CardTitle } from "@/components/ui/card";
// import { ScrollArea } from "@/components/ui/scroll-area";
// import { Separator } from "@/components/ui/separator";
// import { CalendarDaysIcon, PlusIcon } from "lucide-react";
// import { useCallback } from "react";
import { toast } from "sonner";
import createAxios from "@/lib/axios";

// function formatDate(date: Date) {
//   const day = date.getDate();
//   const month = date.toLocaleString("en-GB", { month: "short" });

//   const getOrdinalSuffix = (day: number) => {
//     if (day >= 11 && day <= 13) return day + "th";
//     switch (day % 10) {
//       case 1:
//         return day + "st";
//       case 2:
//         return day + "nd";
//       case 3:
//         return day + "rd";
//       default:
//         return day + "th";
//     }
//   };

//   return `${getOrdinalSuffix(day)} ${month}`;
// }

// function parseCustomDate(dateString?: string): Date {
//   if (!dateString) return new Date();
//   const formattedIsoString = dateString.replace("IST+0530", "+05:30");
//   const date = new Date(formattedIsoString);
//   return isNaN(date.getTime()) ? new Date() : date;
// }

export const Route = createFileRoute("/dashboard/presentation")({
  component: PresentationList,
  loader: async () => {
    try {
      const client = await createAxios();
      const { data } = await client.get<
        { id: string; name?: string; createdAt: string }[]
      >(`${import.meta.env.VITE_BACKEND_URL}/presentations`);
      return { presentations: data || [] };
    } catch (error) {
      toast.error("Error fetching presentations:");
      throw error;
    }
  },
});

function PresentationList() {
  // const { presentations } = Route.useLoaderData();
  // const matchRoute = useMatchRoute();
  // const isMatched = useCallback(
  //   (id: string) => {
  //     return matchRoute({
  //       to: "/dashboard/presentation/$id",
  //       params: { id },
  //     });
  //   },
  //   [matchRoute],
  // );

  return (
    <main className="flex w-full">
      <div className="w-full p-4">
        <Outlet />
      </div>
      {/* <nav className="flex h-screen w-[20vw] shrink-0 flex-col items-start gap-4 bg-[#2b3b54] p-4">
        <Link to="/dashboard/presentation/new" className="w-full">
          <Card className="w-full">
            <CardHeader className="p-4">
              <CardTitle className="flex items-center justify-between gap-2 text-base">
                <span>Create</span>
                <PlusIcon className="size-6" />
              </CardTitle>
            </CardHeader>
          </Card>
        </Link>
        <Separator className="-my-1 bg-muted-foreground" />
        <ScrollArea className="w-full">
          <div className="flex w-full flex-col gap-3">
            {presentations.map((presentation) => (
              <Link
                key={presentation.id}
                to={"/dashboard/presentation/$id"}
                params={{ id: presentation.id }}
                className="w-full"
              >
                <Card
                  className={`w-full ${isMatched(presentation.id) ? "bg-[#e8e9eb]" : "bg-muted-foreground"}`}
                >
                  <CardHeader className="p-4">
                    <h1
                      className="font-semibold"
                      title={presentation.name || presentation.id}
                    >
                      {presentation.name
                        ? presentation.name.length > 20
                          ? presentation.name.slice(0, 20) + "..."
                          : presentation.name
                        : presentation.id.slice(-10)}
                    </h1>
                    <div className="flex items-center gap-1">
                      <CalendarDaysIcon className="size-4" />
                      <p className="text-sm">
                        {formatDate(parseCustomDate(presentation.createdAt))}
                      </p>
                    </div>
                  </CardHeader>
                </Card>
              </Link>
            ))}
          </div>
        </ScrollArea>
      </nav> */}
    </main>
  );
}
